"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault"),
    _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react")),
    _classnames = _interopRequireDefault(require("classnames")),
    _Button = _interopRequireDefault(require("../../../Button")),
    _formModal = require("../../styles/formModal"),
    SaveButton = function SaveButton(a) {
  var b = a.onSave,
      c = a.saving,
      d = a.saveDisabled,
      e = a.saveText;
  return b ? _react["default"].createElement(_Button["default"], {
    className: "modal__save-button",
    busy: c,
    onClick: b,
    disabled: d
  }, e) : null;
};

function ModalFooter(a) {
  var b = a.saveText,
      c = a.closeText,
      d = void 0 === c ? "Cancel" : c,
      e = a.onClose,
      f = a.onSave,
      g = a.saving,
      h = a.saveDisabled;
  return _react["default"].createElement("div", {
    className: (0, _classnames["default"])(_formModal.FOOTER, "modal__footer")
  }, _react["default"].createElement(_Button["default"], {
    onClick: e,
    type: "TERTIARY"
  }, d), _react["default"].createElement(SaveButton, {
    onSave: f,
    saving: g,
    saveDisabled: h,
    saveText: b
  }));
}

ModalFooter.defaultProps = {
  saveDropdownToggle: !1
};

var _default = (0, _react.memo)(ModalFooter);

exports["default"] = _default;